"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partnerDetailsSchema = void 0;
var _zod = require("zod");
var partnerDetailsSchema = t => {
  var genericErrorMessage = t('payApplication.payapp.memorable.error');
  var titleErrorMessage = t('payApplication.companyDetails.nameTitles.required');
  var firstNameErrorMessage = t('payApplication.companyDetails.name.firstName.invalid');
  var lastNameErrorMessage = t('payApplication.companyDetails.name.lastName.invalid');
  return _zod.z.object({
    numberOfPartners: _zod.z.string().regex(/^\d+$/, {
      message: genericErrorMessage
    }).refine(value => Number(value) >= 0 && Number(value) <= 999, {
      message: genericErrorMessage
    }),
    title: _zod.z.object({
      displayValue: _zod.z.string().min(1, titleErrorMessage),
      value: _zod.z.string()
    }),
    foreName: _zod.z.string().min(2, firstNameErrorMessage).max(30, firstNameErrorMessage).regex(/^[A-Za-z\s-]+$/, {
      message: firstNameErrorMessage
    }),
    lastName: _zod.z.string().min(2, lastNameErrorMessage).max(30, lastNameErrorMessage).regex(/^[A-Za-z\s-]+$/, {
      message: lastNameErrorMessage
    })
  });
};
exports.partnerDetailsSchema = partnerDetailsSchema;